<template>
    <div id="select-bno-dialog" class="select-button d-flex">
        <div class="bno-badges-container d-flex flex-wrap" @click="showDialog" @keyup.enter="showDialog"
             tabindex="0">
            <span v-show="!selectedValue.length" class="placeholder">
                {{label ? label : "Diagnózis (BNO)"}}
            </span>
            <div v-for="item in selectedValue" :key="item.id">
                <div>
                    <span class="badge badge-info" @click.stop>
                        {{ options.formatText(item) }}
                        <i class="fas fa-times badge-remove" @click.stop="removeRow(item)"></i>
                    </span>
                <label class="smooth-label" :class="{'required': required}">{{label ? label : "Diagnózis (BNO)"}}</label>
                </div>
            </div>
        </div>

        <div class="align-items-center d-flex search-icon-wrapper" @click="showDialog">
            <span><i class="fas fa-search"></i></span>
        </div>

        <b-modal id="drug-select-modal" size="xl" lazy ref="bno-select-dialog" title="BNO kiválasztása">
            <b-tabs content-class="mt-3" lazy>
                <b-tab title="Aktuális" active>
                    <div class="d-block" :style="cssVars">
                        <DataTable ref="dataTable"
                                   :columns="getHeaderFields"
                                   :additional-config="getDataTableOptions"
                                   :apiCallback="getValidBNO"
                                   @customClick="buttonWasClicked">
                        </DataTable>
                    </div>
                </b-tab>
                <b-tab title="Összes">
                    <div class="d-block" :style="cssVars">
                        <DataTable ref="dataTable"
                                   :columns="getHeaderFields.filter(field => field.name !== 'buttons')"
                                   :additional-config="getDataTableOptions"
                                   :apiCallback="getAllBNO"
                                   @customClick="buttonWasClicked"/>
                    </div>
                </b-tab>
            </b-tabs>


            <template slot="modal-footer" slot-scope="{ cancel }">
                <b-button size="sm" variant="danger" @click="hideDialog">
                    <i class="far fa-times-circle"></i> Bezár
                </b-button>
            </template>
        </b-modal>

    </div>
</template>

<script>
    import Api from "../util/Api";
    import {mapGetters} from "vuex";
    import DataTable from "../components/DataTable";
    import SelectComponent from "@/components/SelectComponent";

    export default {
        name: "SelectBNOMultiDialog",
        components: {
            DataTable,
            SelectComponent
        },
        data() {
            return {
                selectedValue: []
            }
        },
        props: {
            value: {type: Array},
            options: {type: Object},
            required: {type: Boolean, default: false},
            label: {type: String, default: null},
            readOnly: {type: Boolean, default: false},
        },
        computed: {
            ...mapGetters("bnoSelectDialog", ["getDataTableOptions"]),
            ...mapGetters("app", ['getDefaultColor']),
            getHeaderFields: function() {
                return  [
                    {
                        name: "id",
                        label: "ID",
                        visibility: false
                    },
                    {
                        name: "kod",
                        label: "Kód",
                        filter: {
                            type: "simple",
                        },
                        slot_name: "bno_szinezes",
                        sort: true,
                        visibility: true
                    },
                    {
                        name: "leiras",
                        label: "Leírás",
                        filter: {
                            type: "simple",
                        },
                        sort: true,
                        visibility: true
                    },
                    {
                        name: "buttons",
                        label: "Opciók",
                        values: this.value,
                        slot_name: "row_select",
                        sort: false,
                        visibility: true
                    }
            ]},

            cssVars() {
                return {
                    '--default-color': this.getDefaultColor
                }
            },
        },
        methods: {
            showDialog() {
                if (!this.readOnly) {
                    this.$refs['bno-select-dialog'].show();
                }
            },
            hideDialog() {
                this.$refs['bno-select-dialog'].hide();
            },

            selectRow(rowData) {
                this.selectedValue.push(rowData);
                this.$emit('input', this.selectedValue);
            },

            removeRow(data) {
                this.selectedValue = this.selectedValue.filter((item) => data.id !== item.id);
                this.$emit('input', this.selectedValue);
            },

            getAllBNO(params) {
                params.params.filter = {
                    ...params.params.filter
                };
                return Api.getAllBno(params);
            },

            getValidBNO(params) {
                params.params.filter = {
                    ...params.params.filter
                };
                return Api.getAllValidBno(params);
            },

            refreshGrid() {
                this.$refs.dataTable.fetchData();
            },

            buttonWasClicked(event, data) {
                switch (event.event_payload) {
                    case "selectRow":
                        this.selectRow(data);
                        break;
                    case "removeRow":
                        this.removeRow(data);
                        break;
                }
            }

        },
        watch: {
            value: {
                deep: true,
                immediate: true,
                handler: function (val) {
                    if (val) {
                        this.selectedValue = val;
                    }
                }
            }
        }
    }
</script>

<style scoped>
</style>
